module.exports = "<div id=\"page\" data-aos=\"zoom-in\" data-aos-delay=\"800\">\n    <h1 id=\"title\">Claudio La Barbera</h1>\n    <h2 id=\"subtitle\">Web developer</h2>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/claudio/Projects/thebatclaudio.github.io/src/app/home/home.component.html
// module id = ../../../../../src/app/home/home.component.html
// module chunks = main